import { tabDetailsHandler } from "@redux/LogisticsProfile/logisticsProfileSlice";
import { logisticsEvent, logisticsTabData, profileTypeEnum } from "@components/templates/Profile/ProfileHeader/profile-enum";
import ProfilePanel from "@components/templates/Profile/ProfilePanel/ProfilePanel";
import { generateTrackingObject } from "@core/global/global-country-functions";
import { trademoTrackingEvents } from "@core/global/trademo-tracking";
import { getEventName, getUserActivePlan, renderLogisticsPanelData } from "@helpers/profileHelper";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import trackingEventDictionary from "@core/dictionary/tracking-event";

const Panel = () => {
  const { tabDetails, countDetails } = useSelector((state) => state.logisticsProfile);
  const { activeTabId } = tabDetails;
  const { loading } = countDetails;
  const [panelData, setPanelData] = useState(logisticsTabData);
  const dispatch = useDispatch();
  const { search: searchUrlParams, pathname } = useLocation();
  const dataSource = new URLSearchParams(searchUrlParams).get("dataSource");

  useEffect(() => {
    const filteredPanel = [];
    logisticsTabData.map((tab) => {
      if ((tab.countEnum && countDetails[tab.countEnum] > 0) || tab.isExcludeFilter) {
        filteredPanel.push({ ...tab, count: countDetails[tab.countEnum] });
      }
    });
    setPanelData(filteredPanel);
  }, [countDetails]);

  const handlePanelClick = (id) => {
    if (id === "contact_details") {
      trademoTrackingEvents(trackingEventDictionary.logisticsCompanyProfilePageRequestContactDetailsTab, generateTrackingObject(dataSource, pathname, getUserActivePlan()));
    } else {
      trademoTrackingEvents(getEventName(profileTypeEnum.logistics, logisticsEvent[id].tab), generateTrackingObject(dataSource, pathname, getUserActivePlan()));
    }
    trademoTrackingEvents(getEventName(profileTypeEnum.logistics, logisticsEvent[id].tab), generateTrackingObject(dataSource, pathname, getUserActivePlan()));
    dispatch(
      tabDetailsHandler({
        ...tabDetails,
        activeTabId: id,
      })
    );
  };
  return panelData && panelData.length > 0 ? (
    <>
      <ProfilePanel panelData={panelData} handlePanelClick={handlePanelClick} activePanelId={activeTabId} loading={loading} />
      {renderLogisticsPanelData(activeTabId, countDetails)}
    </>
  ) : null;
};

export default Panel;
